import { render, staticRenderFns } from "./FeedbackIndicacaoFinalizada.vue?vue&type=template&id=66655d68"
import script from "./FeedbackIndicacaoFinalizada.vue?vue&type=script&lang=js"
export * from "./FeedbackIndicacaoFinalizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports